import { useTranslation } from "react-i18next";
import {
  InvestmentListView,
  InvestmentSortField,
  TEXT_SORT_FIELDS,
  isTextSortField,
} from "@features/investments/investment/components/InvestmentTable/mobile";
import { DirectionLabel, SortOption } from "@components/MobileList";

// Every field in both directions, its usual one first: text A to Z, values
// with the largest first.
export const useInvestmentSortOptions = (
  view: InvestmentListView
): SortOption<InvestmentSortField>[] => {
  const { t } = useTranslation();

  return [...TEXT_SORT_FIELDS, ...view.metricOrder].flatMap((field) => {
    const isText = isTextSortField(field);
    const directions: TableSortDirection[] = isText
      ? ["ASC", "DESC"]
      : ["DESC", "ASC"];
    const fieldLabel = t(
      `domains.investments.investmentTable.mobile.fields.${field}`
    );
    return directions.map((direction) => {
      const directionText = t(
        `domains.investments.investmentTable.mobile.${direction === "ASC" ? "ascending" : "descending"}${isText ? "Text" : "Number"}`
      );
      return {
        field,
        direction,
        // "A to Z" reads clearly; values get the arrow instead of a word.
        label: isText ? (
          t("domains.investments.investmentTable.mobile.sortOption", {
            field: fieldLabel,
            direction: directionText,
          })
        ) : (
          <DirectionLabel
            field={fieldLabel}
            direction={direction}
            directionText={directionText}
          />
        ),
      };
    });
  });
};
